import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Linkedin({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 17 13"
    >
      <Path
        d="M16.0949 0.546387H1.57693C1.17917 0.546387 0.880859 0.844702 0.880859 1.24246V15.8599C0.880859 16.1582 1.17917 16.4565 1.57693 16.4565H16.1944C16.5921 16.4565 16.8905 16.1582 16.8905 15.7605V1.24246C16.791 0.844702 16.4927 0.546387 16.0949 0.546387ZM5.55447 14.07H3.26738V6.5127H5.65391V14.07H5.55447ZM4.46064 5.51831C3.66514 5.51831 3.06851 4.82224 3.06851 4.12617C3.06851 3.33066 3.66514 2.73403 4.46064 2.73403C5.25615 2.73403 5.85278 3.33066 5.85278 4.12617C5.75335 4.82224 5.15671 5.51831 4.46064 5.51831ZM14.4045 14.07H12.018V10.3908C12.018 9.49585 12.018 8.40203 10.8247 8.40203C9.63145 8.40203 9.43257 9.39641 9.43257 10.3908V14.1695H7.04605V6.5127H9.33313V7.50708C9.63145 6.91045 10.427 6.31382 11.5208 6.31382C13.9073 6.31382 14.3051 7.90483 14.3051 9.8936V14.07H14.4045Z"
        fill={iconColor}
      />
    </Svg>
  );
}
